import { connect } from "react-redux";
import { resetData } from "./redux/login-reducer";

let LogOut = (props) => {
  let leaveSession = () => {
    localStorage.removeItem("token");
    props.resetData();
    window.location.href = "/login";
  };
  return <button onClick={leaveSession}>Log Out</button>;
};

let LogOutContainer = connect(null, {
  resetData,
})(LogOut);

export default LogOutContainer;
